const getStarredSpaces = (spaces) => {
  const starredCategory = {
    label: 'Starred spaces',
    order: -1,
  };

  return spaces
    .filter((space) => space.isStarred && !space.archived)
    .map((space) => ({
      ...space,
      categories: [starredCategory],
    }))
    .sort((a, b) => a.name.localeCompare(b.name));
};

export default getStarredSpaces;
